import { reduxStoreTypes } from '@/type/redux-store';

export const SET_TARGET: reduxStoreTypes.TargetType = 'SET_TARGET';
export const GET_TARGET: reduxStoreTypes.TargetType = 'GET_TARGET';
export const setTarget = (params: Omit<reduxStoreTypes.TargetAction, 'type'>) => ({
    type: SET_TARGET,
    ...params
})

export const getTarget = (params: Omit<reduxStoreTypes.TargetAction, 'type'>) => ({
    type: GET_TARGET,
    ...params
})